import { useState } from "react";

import { ListModal } from "molecules/modal-window/list-modal/ListModal";

interface Props {
  hideText?: boolean;

  /** Specify the testid for current component */
  "data-testid"?: string;
}

export const TermsAndCondition = ({
  hideText = false,
  "data-testid": dataTestId,
}: Props) => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleTermsOpenClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setOpenModal(true);
  };

  return (
    <div className="py-6 text-center text-body3 text-secondary">
      {!hideText && (
        <div className="flex flex-col pb-1" data-testid={dataTestId}>
          {/* hardcode the terms and conditions for now */}
          Important Terms and Conditions: All financing subject to credit
          approval. APRs depend on creditworthiness, term length, and other
          factors. “As low as” does not guarantee your rate or payment options
          as this is dependent on your creditworthiness. Check with your
          provider about additional amounts required for procedure that may be
          ineligible for financing. Scheduled payments in example based on the
          full 24-month term. Length of financing is up to you and/or your
          creditworthiness.
        </div>
      )}
      <a href="#" className="underline" onClick={handleTermsOpenClick}>
        {"View "}
        {!hideText && "additional "}
        Terms and Conditions and Checkout Agreement here
      </a>
      <ListModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        size="fullscreen"
        title="CHECKOUT AGREEMENT"
      >
        <div className="gap-0 p-4 pb-6 text-body3 text-primary">
          <div className="pb-2 uppercase">
            Important terms as of September 9, 2025
          </div>
          <div className="py-2">
            <div className="pb-2 text-bold2">CHECKOUT AGREEMENT</div>

            <p className="py-1">
              THIS AGREEMENT GOVERNS YOUR ACQUISITION AND USE OF THE TREATMENT
              PROVIDER&apos;S SERVICES. BY ENTERING INTO THIS AGREEMENT, YOU
              AGREE TO THE TERMS OF THIS AGREEMENT, INCLUDING THOSE ADDITIONAL
              TERMS AND CONDITIONS AND POLICIES REFERENCED HEREIN. DEPENDING ON
              YOUR LOCATION, YOU MAY BE SUBJECT TO ADDITIONAL OR DIFFERENT
              PROVISIONS SET FOR IN ONE OR MORE EXHIBITS OR APPENDICES TO THIS
              AGREEMENT, WHICH MAY BE UPDATED FROM TIME-TO-TIME.
            </p>

            <div className="py-2 text-bold2 text-bold2 underline">
              Article I. Definitions.
            </div>
            <p className="py-1">
              In addition to defined terms elsewhere in this Agreement, the
              following terms have the meaning given to them in this Article I:
            </p>
            <p className="py-1">
              (a) &quot;Affiliate&quot; of a Person means any other Person that
              directly or indirectly, through one or more intermediaries,
              controls, is controlled by, or is under common control with, such
              Person. The term &quot;control&quot; (including the terms
              &quot;controlled by&quot; and &quot;under common control
              with&quot;) means the direct or indirect power to direct or cause
              the direction of the management and policies of a Person, whether
              through the ownership of voting securities, by contract, or
              otherwise.
            </p>
            <p className="py-1">
              (b) &quot;Agreement&quot; means this Checkout Agreement, together
              with any and all exhibits of appendices referenced herein.
            </p>
            <p className="py-1">
              (c) &quot;Billing Period&quot; means the recurring time interval
              selected by the Treatment Provider and/or You (as shown on the
              Order Summary), which governs the frequency of Membership Dues,
              the duration of Your Membership, and renewal terms (e.g., weekly,
              monthly, annually).
            </p>
            <p className="py-1">
              (d) &quot;Effective Date&quot; is the effective date of this
              Agreement, which occurs on the date You first signed this
              Agreement or otherwise first accessed or used the Platform
              (whether through the Website or the App).
            </p>
            <p className="py-1">
              (e) &quot;Membership&quot; means a recurring subscription to
              Treatment Provider.
            </p>
            <p className="py-1">
              (f) &quot;Person&quot; means an individual, corporation,
              partnership, joint venture, limited liability entity, governmental
              authority, unincorporated organization, trust, association, or
              other entity.
            </p>
            <p className="py-1">
              (g) &quot;Platform&quot; means Your Treatment Provider&apos;s
              white-labeled version of the RepeatMD proprietary Platform, which
              is made available via the RepeatMD website (the
              &quot;Website&quot;) and mobile application (the &quot;App&quot;),
              and which allows You to collect rewards and/or purchase
              Memberships, Treatments, Physical Products, Packages, or related
              items and services from Treatment Providers, including cards or
              certificates for a specified cash value of goods or services (a
              &quot;Gift Card&quot;).
            </p>
            <p className="py-1">
              (h) &quot;RepeatMD&quot; means RepeatMD, Inc., a Delaware
              corporation. If You are using the Platform in Canada, then
              &quot;RepeatMD&quot; refers to RepeatMD Canada.
            </p>
            <p className="py-1">
              (i) &quot;RepeatMD Canada&quot; means RepeatMD Canada, Inc., an
              Ontario corporation.
            </p>
            <p className="py-1">
              (j) &quot;Treatment Provider&quot; is defined as a Person or
              facility where You receive Treatments. Your &quot;Treatment
              Provider&quot; is where your Membership or Treatment was
              purchased.
            </p>
            <p className="py-1">
              (k) &quot;Treatment Provider Facility&quot; is where your
              Treatments will be performed.
            </p>
            <p className="py-1">
              (l) &quot;Treatment&quot; is any service performed by a Treatment
              Provider at a Treatment Provider Facility.
            </p>
            <p className="py-1">
              (m) &quot;Physical Product&quot; is any physical good purchased
              through a Treatment Provider or third-party supplier partnered
              with RepeatMD.
            </p>
            <p className="py-1">
              (n) &quot;Package&quot; means a collection of some amount of
              Treatments.
            </p>
            <p className="py-1">
              (o) &quot;You&quot; or &quot;Your&quot; means the natural Person
              who has signed this Agreement or who has otherwise agreed to be
              bound by its terms, and who is receiving Treatments from the
              Treatment Provider.
            </p>
            <p className="py-1">
              (p) &quot;Your Data&quot; means the electronic data and
              information (in any format or media) entered, submitted by,
              processed, or otherwise made accessible to RepeatMD by You or Your
              device through the Platform and that RepeatMD collects, accesses,
              or otherwise processes in connection therewith.
            </p>

            <div className="py-2 text-bold2 text-bold2 underline">
              Article II. Description of Users and Acceptance of Terms.
            </div>
            <p className="py-1">
              By accessing or using the Platform (whether through the Website or
              the App, and whether or not You have purchased a Treatment,
              Package, Product, Membership, or Gift Card), You:
            </p>
            <ul className="list-disc pl-6">
              <li className="py-1">
                Are agreeing to the terms of this Agreement and any other
                accompanying policies, including the Privacy Policy and the
                Terms of Use;
              </li>
              <li className="py-1">
                If You purchase a Membership, are committing to an obligation
                period as stated on Your Order Summary page which You cannot
                cancel early, except for the limited reasons specifically set
                forth in this Agreement; and
              </li>
              <li className="py-1">
                Acknowledge and agree that You have carefully read and
                understand this Agreement, and will comply with all terms herein
                and with any and all of Treatment Provider Policies described in
                this Agreement.
              </li>
            </ul>

            <div className="py-2 text-bold2 text-bold2 underline">
              Article III. Membership Terms.
            </div>

            <div className="py-2 text-bold2">
              Section III.01 Your Membership.
            </div>
            <p className="py-1">
              <strong>(a) Overview.</strong> This Agreement sets forth the terms
              and conditions that apply to Your Membership, Your use of the
              Platform, and/or Your use of any limited term rewards or other
              benefits (including pursuant to a one-time or multi-use “pass” or
              Gift Card) at Treatment Provider. You are responsible for
              complying with this Agreement. A copy of your Agreement is
              available at memberships@repeatmd.com.
            </p>
            <p className="py-1">
              <strong>(b) Minimum Commitment.</strong> Your Membership has an
              initial commitment period that is stated on Your Order Form page
              during checkout (the “Initial Period”) and, except for those
              limited cancellation rights expressly set forth in this Agreement,
              you may not cancel Your Membership or otherwise terminate this
              Agreement during the Initial Period. In addition to any other
              cancellation rights expressly set forth herein, You have the right
              to cancel Your Membership by midnight of the third (3rd) business
              after the Effective Date but only if no rewards or other items on
              the Platform have been claimed. See Section 3.01(a) of this
              Agreement for more information. You also have certain rights to
              cancel this Agreement if the Treatment Provider goes out of
              business or relocates or if you die or become totally and
              permanently disabled. See Section 3.03(b) of this Agreement for
              more information.
            </p>
            <p className="py-1">
              <strong>(c) Renewals.</strong> All Memberships automatically renew
              at the end of the Initial Period and continue for the same billing
              period defined at the time of purchase (e.g., monthly, yearly,
              every 28 days), as configured by the Treatment Provider, unless
              cancelled by You or the Treatment Provider in accordance with
              Section 3.03. RepeatMD and/or Treatment Provider will provide You
              with notice of renewal at least thirty (30) days prior to the end
              of the Initial Period (whether via email, SMS, or in-App
              notification), unless a longer period is required by applicable
              law. You may cancel Your Membership at any time through the
              RepeatMD App or Website, provided any minimum commitment period
              set by the Treatment Provider has been met. Alternatively, you may
              cancel by providing written notice of cancellation no less than
              thirty (30) days prior to the expiration of the Initial Period (or
              any subsequent period). Notices of termination may also be sent to
              the Treatment Provider and RepeatMD at memberships@repeatmd.com.
            </p>
            <p className="py-1">
              <strong>(d) Non-Transferable.</strong> Your Membership is personal
              to you and You may not transfer, assign, or devise Your
              Membership. Only You may use Your Membership, and You may not
              permit any other Person to access and use your Membership.
              RepeatMD has the right to immediately terminate Your Membership if
              you violate this Section 3.01(d).
            </p>
            <p className="py-1">
              <strong>(e) Treatment Provider Facility Closures.</strong> During
              Your Membership, Treatment Provider may, in its sole discretion,
              temporarily close or suspend or limit Your access to certain
              Treatment Provider Facilities or areas, features or amenities for
              any reasonable or necessary purposes, including for purposes of
              renovation, special events or otherwise, at any time and in its
              sole discretion.
            </p>
            <p className="py-1">
              <strong>(f) Special Provisions for Gift Cards.</strong> If You
              purchase or receive a Gift Card, the following additional
              provisions apply. Gift Cards are only available in digital format
              and may only be purchased with credit cards or debit cards (i.e.,
              financing options, including through Affirm, are not available).
              Gift Cards are specific to a particular Platform and Treatment
              Provider; accordingly, You may only use a Gift Card on the
              Platform and at the Treatment Provider from which it was
              purchased. You may not redeem a Gift Card for cash. Once
              purchased, a Gift Card will be automatically added to Your
              RepeatCash balance in the App. Gift Cards are non-transferrable.
              Unless otherwise stated on the Gift Card or at the time of
              purchase, Gift Cards to not expire.
            </p>

            <div className="py-2 text-bold2">
              Section III.02 Payment Policies.
            </div>
            <p className="py-1">
              <strong>(a) Membership Dues.</strong> During the Initial Period,
              Your Membership dues (&quot;Membership Dues&quot;) will not
              change. After the Initial Period, Your Membership Dues may
              increase or otherwise change in accordance with the terms set
              forth in Your Order Form or any renewal notice, including to
              reflect price increases associated with new or enhanced features
              and benefits in the Platform or as part of Your Membership.
              Membership Dues are not based on or related to actual usage of
              Treatments provided by Treatment Provider. You are responsible for
              the payment of Your Membership Dues in full regardless of Your use
              of, or failure to use, the Treatment Provider in accordance with
              the applicable Billing Schedule.
            </p>
            <p className="py-1">
              <strong>(b) Ancillary Charges.</strong> You are responsible for
              paying all amounts You incur during Your Membership, including,
              without limitation, fees for other ancillary services, as well as
              purchases of retail or other items (collectively, &quot;Ancillary
              Charges&quot;). Payment for Ancillary Charges is due in full at
              the time of purchase, and Treatment Provider has no obligation to
              provide you with any ancillary service or good until it has
              received such payment. Pricing for all Ancillary Charges is in
              Treatment Provider&apos;s discretion and may be prospectively
              modified by Treatment Provider at any time, with or without notice
              to you.
            </p>
            <p className="py-1">
              <strong>(c) Non-Refundable.</strong> All fees for or associated
              with Your Membership, including, if applicable, Your initiation
              fee, Membership Dues and Ancillary Charges, are non-refundable
              and, unless otherwise expressly set forth in this Agreement, you
              will not receive a refund of any such fees, whether as a result of
              a cancellation of Your Membership or otherwise. From time to time
              Treatment Provider may provide you with certain complimentary or
              promotional items. Complimentary items have no cash value and you
              are not entitled to any refund or other amount for any
              complimentary item.
            </p>
            <p className="py-1">
              <strong>(d) Good Standing.</strong> You are required to keep your
              Membership in good standing by ensuring all Membership Dues and
              any Ancillary Charges are paid on time. You are responsible for
              promptly notifying Treatment Provider of any changes to Your
              credit card, checking account or other payment account information
              (&quot;Payment Information&quot;). You may update Your Payment
              Information in the App.
            </p>
            <p className="py-1">
              <strong>(e) Separate Buyer.</strong> If another individual (a
              &quot;Buyer&quot;) purchased Your Membership on Your behalf and
              agreed to have their Payment Information retained on-file with
              Treatment Provider, You, not the Buyer, are ultimately liable for
              all Membership Dues and Ancillary Charges payable hereunder and
              You agree to make all payments hereunder in the event the Buyer
              fails to do so. Further, by using the Platform, You represent and
              warrant to Treatment Provider and RepeatMD that the Buyer had all
              necessary authority to purchase Your Membership. This Agreement
              does not provide the Buyer with any rights of Membership and the
              Buyer may not access and use Treatment Provider under your
              Membership.
            </p>
            <p className="py-1">
              <strong>(f) Past-Due Balances.</strong> Treatment Provider
              reserves the right to take any lawful action in response to any
              past-due Membership Dues and/or Ancillary Charges, including,
              without limitation: (1) charging the Payment Information then
              on-file with Treatment Provider; (2) cancelling Your Membership or
              otherwise suspending Your access to Treatment Provider until all
              past-due amounts are paid; (3) charging You interest on past-due
              amounts at rates permitted by applicable law; and/or (4) providing
              Your information, including without limitation name and contact
              information, to a collections agency who will attempt to collect
              Your past-due amounts on behalf of Treatment Provider. You will be
              responsible for any collection and/or legal costs incurred by
              Treatment Provider in collecting any past-due amounts associated
              with Your Membership. Treatment Provider may charge You a $20 fee
              for each credit card charge or ACH transfer that is dishonored or
              rejected as invalid. Please note that cancellation of Your
              Membership will not relieve You of Your obligation to pay any
              past-due or outstanding amounts.
            </p>

            <div className="py-2 text-bold2">
              Section III.03 Cancellation Rights.
            </div>
            <p className="py-1">
              <strong>(a) Cancellation of Contract for Full Refund.</strong> IF
              YOU DECIDE YOU DO NOT WISH TO REMAIN A MEMBER OF TREATMENT
              PROVIDER, YOU MAY CANCEL THIS AGREEMENT AND YOUR MEMBERSHIP BY
              EMAILING MEMBERSHIPS@REPEATMD.COM BY MIDNIGHT OF THE THIRD (3RD)
              BUSINESS DAY AFTER THE EFFECTIVE DATE OF THIS. YOUR EMAIL MUST
              SPECIFICALLY STATE YOUR DESIRE TO CANCEL THIS AGREEMENT.
            </p>
            <p className="py-1">
              <strong>(b) Additional Rights to Cancel.</strong> You may also
              cancel Your Membership and this Agreement, at any time during or
              after the Initial Period, for either of the following reasons: (i)
              if Your Treatment Provider goes out of business or if Treatment
              Provider moves more than twenty-five (25) miles from the preceding
              location, you may cancel this Agreement by email stating your
              desire to cancel this Agreement, accompanied by proof of payment
              on Your Agreement to: memberships@repeatmd.com; or (ii) if You die
              or become totally and permanently disabled after the Effective
              Date of this Agreement, Your estate may cancel this Agreement and
              receive a partial refund of Your unused Membership Fee by emailing
              a notice to Treatment Provider stating your desire to cancel this
              Agreement. Treatment Provider may require proof of disability or
              death. The written notice must be email to the following address:
              memberships@repeatmd.com. Treatment Provider may require You or
              Your estate to provide reasonable proof of your disability or
              death, such as a signed letter from your doctor or a copy of your
              death certificate. Notice should be accompanied by a receipt or
              other proof of payment made under this Agreement, as well as any
              membership cards or fobs or other Membership documentation given
              to You by Treatment Provider.
            </p>
            <p className="py-1">
              <strong>(c) Refunds for Certain Cancellations.</strong> For
              cancellations properly made under Section 3.03(b), within thirty
              (30) days after Treatment Provider receives notice of such
              cancellation, it will refund, using the Payment Information
              on-file, any unearned payments. Unearned payments will be
              determined in the reasonable discretion of the Treatment Provider
              based upon the number of Treatments remaining and/or the remaining
              period of Your Membership. A Treatment Provider’s determinations
              in this regard are final and binding.
            </p>
            <p className="py-1">
              <strong>(d) Cancellation after Initial Period.</strong> If You do
              not wish to continue your Membership after the Initial Period, You
              may cancel Your Membership and this Agreement (i) in the App (the
              preferred method of cancellation) or (ii) by providing written
              notice of cancellation at least thirty (30) days prior to the end
              of the Initial Period (or, if applicable, any subsequent renewal
              period). Notice should be provided to: MEMBERSHIPS@REPEATMD.COM.
              For clarity, notices of cancellation will be effective at the end
              of the Initial Period or the then-applicable renewal period,
              regardless of whether You provide notice more than thirty (30)
              days prior to expiration prior to Initial Period or
              then-applicable renewal period. You are required to pay all
              Membership Dues for the Initial Period or renewal period even if
              You submit a cancellation notice more than thirty (30) days before
              the Initial Period or renewal period ends. Please note You will
              not receive a refund of any charges, including but not limited to
              unused Treatments at the time Your cancellation goes into effect.
            </p>
            <p className="py-1">
              <strong>(e) Record of Cancellation.</strong> You are responsible
              for retaining (and providing, if necessary) all records relating
              to Your cancellation of Membership. In the event of a dispute as
              to whether and when notice of cancellation was received, Treatment
              Provider’s records will control.
            </p>
            <p className="py-1">
              <strong>(f) Revocation of Membership.</strong> Treatment Provider
              may, in its discretion, revoke or suspend Your Membership, or
              limit Your right to access certain Treatment Provider Facilities
              or participate in certain Treatment Provider offerings or
              ancillary services, upon notice to You provided at any time and
              for any reason, including without limitation failure to pay
              Membership Dues or Ancillary Charges or failure to comply with
              Treatment Provider Policies (as defined below). In some cases,
              notice of revocation or suspension may be provided orally by
              Treatment Provider or one of its authorized representatives. If
              Treatment Provider revokes Your Membership, it will promptly
              refund, using the Payment Information on-file with Treatment
              Provider, any prepaid unused Membership Dues and any prepaid
              unused Ancillary Charges, less any outstanding amounts which may
              be owed to Treatment Provider hereunder. Revocation or suspension
              of Membership will be without limitation to any other rights or
              remedies which Treatment Provider may have at law or in equity,
              and Treatment Provider reserves the right to, in its discretion,
              prohibit you from rejoining Treatment Provider in the future.
            </p>

            <div className="py-2 text-bold2">Section III.04 Your Health.</div>
            <p className="py-1">
              <strong>(a) Health Warranty.</strong> By purchasing a Membership
              and using Treatment Provider, You represent and warrant to
              Treatment Provider and RepeatMD at all relevant times that: (i)
              You are in good health and have no injury, impairment, disability,
              disease, ailment or condition that prevents you from safely
              engaging in Treatments or that increases Your risk of injury or
              adverse health consequences as a result of engaging in Treatments;
              and (ii) You are medically fit to receive and engage in
              Treatments. You are encouraged to see Your doctor on a regular
              basis and seek their advice prior to engaging in any new or
              modified treatment regimen or if You have any questions or
              concerns regarding your treatment regimen or the diagnosis of any
              medical conditions.
            </p>
            <p className="py-1">
              <strong>(b) Responsibility to Notify.</strong> You are responsible
              for notifying Treatment Provider before any Treatment of any
              limitation to your ability to participate, including without
              limitation if you have any pre-existing or current injuries,
              impairments, disabilities, diseases, ailments or conditions that
              may prevent or affect your participation. You are also responsible
              for immediately informing your Treatment Provider if You
              experience any pain or discomfort and/or if You cannot or do not
              wish to continue your Treatment. IF YOU EXPERIENCE ANY PAIN,
              DIFFICULTY, DIZZINESS, ILLNESS OR DISCOMFORT WHEN ENGAGING IN ANY
              SESSION, ACTIVITY OR OTHERWISE, STOP AND CONSULT YOUR DOCTOR OR
              SEEK EMERGENCY MEDICAL ATTENTION IMMEDIATELY. You hereby
              acknowledge that You may receive medical treatment or other
              emergency care (as determined by emergency professionals) while at
              Treatment Provider Facilities, to the extent such care may be
              deemed advisable by emergency professionals in the event of
              injury, accident, illness and/or other incapacitation while at any
              Treatment Provider Facilities.
            </p>
            <p className="py-1">
              <strong>(c) Assumption of Risk; Indemnification.</strong> By
              purchasing a Membership and using Treatment Provider, You
              acknowledge and agree that the activities you may engage in at the
              Treatment Provider Facilities, including without limitation when
              participating in any Treatment, involves risks and danger inherent
              in engaging in such Treatments. Specific risks vary from one
              Treatment to another, and range from minor injuries to major
              injuries, including death. In consideration of the Membership
              privileges provided to You hereunder and on behalf of Your heirs,
              beneficiaries, distributees, legal representatives, successors,
              assigns and guests, You hereby voluntarily and knowingly
              acknowledge and assume all risks when undergoing any Treatments by
              any Treatment Provider and You hereby agree to indemnify, defend,
              and hold harmless RepeatMD, its Affiliates, and their respective
              agents, employees, officers, attorneys, shareholders, directors,
              and partners (the “Indemnified Parties”) from and against any and
              all losses, claims (including any claims for property damage,
              personal injury, or injury to others or death), demands, suits,
              proceedings, damages, liabilities, penalties, costs (including
              reasonable attorneys’ fees and costs) (collectively, “Losses”)
              incurred by or asserted against any Indemnified Party arising
              from, related to, or based upon: (i) Your receipt of or engaging
              in Treatments or use of a Treatment Provider, including without
              limitation Your failure to exercise reasonable care when receiving
              Treatments; (ii) Your breach of any representation, warranty, or
              covenant under this Agreement; or (iii) your negligent or more
              culpable conduct in connection with receiving Treatments. Further,
              you acknowledge that Treatment Provider does not manufacture any
              equipment, tools, or machinery used in its Treatment Provider
              Facilities and agree that Treatment Provider is providing
              Treatments and may not be held liable for defective products. For
              the avoidance of doubt, Your obligation to indemnify includes both
              direct claims and third-party claims.
            </p>
            <p className="py-1">
              <strong>(d) Waiver of Certain Damages.</strong> IN CONSIDERATION
              OF THE MEMBERSHIP PRIVILEGES PROVIDED TO YOU HEREUNDER, AND ON
              BEHALF OF YOUR HEIRS, BENEFICIARIES, DISTRIBUTEES, LEGAL
              REPRESENTATIVES, SUCCESSORS, ASSIGNS AND GUESTS, YOU ACKNOWLEDGE
              AND AGREE THAT: REPEATMD AND ITS AFFILIATES WILL NOT BE LIABLE TO
              YOU OR ANY OTHER PERSON FOR ANY LOSSES OR DAMAGES, WHETHER DIRECT,
              INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR
              EXEMPLARY, INCLUDING WITHOUT LIMITATION FOR ANY PROPERTY LOSS OR
              DAMAGE, LOSS OF EARNINGS OR EARNING CAPACITY, PERSONAL INJURY,
              ILLNESS OR IMPAIRMENT, PHYSICAL PAIN, MENTAL ANGUISH, PARALYSIS,
              HEART ATTACK OR DEATH, ARISING OUT OF, IN CONNECTION WITH OR
              RELATED TO THIS AGREEMENT, YOUR MEMBERSHIP, THE USE OR NON-USE OF
              ANY SERVICE, PRODUCT OR EQUIPMENT PROVIDED OR OFFERED HEREUNDER,
              WHETHER RELATED TO TREATMENT OR NOT AND REGARDLESS OF LEGAL THEORY
              OR WHETHER ARISING IN OR BY STATUTE, TORT, CONTRACT, STRICT
              LIABILITY, BREACH OF WARRANTY OR OTHERWISE, INCLUDING THOSE LOSSES
              OR DAMAGES RESULTING FROM OR CAUSED BY, IN WHOLE OR IN PART, THE
              NEGLIGENCE OR GROSS NEGLIGENCE OF ANY TREATMENT PROVIDER PARTY AND
              REGARDLESS OF WHETHER SUCH LOSSES OR DAMAGES ARE KNOWN OR UNKNOWN
              TO YOU OR ANY OTHER PERSON; PROVIDED THAT THE FOREGOING SHALL NOT
              APPLY TO ANY LOSSES OR DAMAGES TO THE EXTENT PROHIBITED BY LAW.
            </p>
            <p className="py-1">
              <strong>
                (e) YOU ACKNOWLEDGE AND AGREE THAT REPEATMD HAS MADE NO
                REPRESENTATIONS OR WARRANTIES, WHETHER EXPRESS, IMPLIED, OR
                STATUTORY, REGARDING TREATMENT PROVIDER OR THE SERVICES OR
                TREATMENTS PROVIDED BY ANY TREATMENT PROVIDER. REPEATMD
                SPECIFICALLY DISCLAIMS ALL IMPLIED WARRANTIES, INCLUDING ANY
                IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                PURPOSE OR NON-INFRINGEMENT AND ANY IMPLIED WARRANTY ARISING
                FROM COURSE OF PERFORMANCE, COURSE OF DEALING, OR USAGE OF
                TRADE. FURTHER, YOU RECOGNIZE, ACKNOWLEDGE, AND AGREE THAT
                REPEATMD IS ONLY A TECHNOLOGY PROVIDER FOR TREATMENT PROVIDER
                AND A PAYMENT PROCESSOR WITH NO CONTROL OVER YOU, YOUR HEALTH,
                TREATMENTS, TREATMENT SAFETY, TREATMENT PROVIDER, TREATMENT
                PROVIDER FACILITIES, OR TREATMENT PROVIDER EQUIPMENT. YOU
                UNDERSTAND AND AGREE THAT REPEATMD IS NOT ENGAGED IN THE
                PRACTICE OF MEDICINE, HAS NOT QUALIFIED ANY PARTICULAR TREATMENT
                PROVIDER, AND THAT OUR SERVICES ARE NOT A SUBSTITUTE FOR
                COMPETENT MEDICAL ADVICE AND THE PROFESSIONAL JUDGMENT OF YOUR
                TREATMENT PROVIDERS.
              </strong>
            </p>
            <p className="py-1">
              <strong>
                (f) IN NO EVENT WILL THE AGGREGATE LIABILITY OF ANY PARTY OR
                OTHER PERSON ARISING OUT OF OR RELATED TO THIS AGREEMENT, UNDER
                ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT,
                TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, AND OTHERWISE,
                EXCEED THE AMOUNT PAID BY YOU TO TREATMENT PROVIDER HEREUNDER IN
                THE 12 MONTHS PRECEDING THE INCIDENT OR CLAIM AT ISSUE. THE
                ABOVE LIMITATIONS WILL NOT APPLY TO: (A) TREATMENT PROVIDER’S
                RECKLESS OR GROSSLY NEGLIGENT ACTS OR OMISSIONS; (B) YOUR
                PAYMENT OBLIGATIONS UNDER THIS AGREEMENT; OR (C) YOUR
                INDEMNIFICATION OBLIGATIONS UNDER THIS AGREEMENT. EXCEPT FOR (A)
                TREATMENT PROVIDER’S RECKLESS OR GROSSLY NEGLIGENT ACTS OR
                OMISSIONS; (B) YOUR PAYMENT OBLIGATIONS UNDER THIS AGREEMENT; OR
                (C) YOUR INDEMNIFICATION OBLIGATIONS UNDER THIS AGREEMENT, IN NO
                EVENT WILL EITHER PARTY OR ANY OTHER PERSON BE LIABLE UNDER OR
                IN CONNECTION WITH THIS AGREEMENT UNDER ANY LEGAL OR EQUITABLE
                THEORY, INCLUDING BREACH OF CONTRACT, TORT (INCLUDING
                NEGLIGENCE), STRICT LIABILITY, AND OTHERWISE, FOR ANY
                CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL,
                ENHANCED, OR PUNITIVE DAMAGES REGARDLESS OF WHETHER EITHER PARTY
                WAS ADVISED OF THE POSSIBILITY OF SUCH LOSSES OR DAMAGES OR SUCH
                LOSSES OR DAMAGES WERE OTHERWISE FORESEEABLE. THE FOREGOING WILL
                NOT APPLY TO THE EXTENT PROHIBITED BY LAW.
              </strong>
            </p>

            <div className="py-2 text-bold2">
              Section III.05 Membership Policies.
            </div>
            <p className="py-1">
              <strong>(a) Treatment Provider Policies.</strong> Treatment
              Provider may adopt, implement, and update various policies and
              procedures relating to the provision of Treatments, the use of
              Treatment Provider Facilities, or other matters pertaining to
              health, safety, and wellness (collectively, &quot;Treatment
              Provider Policies&quot;). You must comply with Treatment Provider
              Policies at all times during the term of this Agreement.
              Treatments will be available to You as long as You are in
              compliance with this Agreement. Unless Your Treatment Provider has
              enabled the &quot;rollover&quot; of rewards feature in the
              Platform, (i) upon termination or expiration of this Agreement (or
              cancellation of Your Membership), all unused Treatments (other
              than special bonus treatments, such as sign-up bonuses that You
              previously earned) shall automatically terminate and expire, and
              shall no longer be available for You to use and (ii) no credits,
              refunds, or other rewards will be given to You for unused
              Treatments that expire or terminate as set forth herein.
            </p>

            <p className="py-1">
              <strong>(b) Your Information.</strong> Treatment Provider, its
              Affiliates, and their respective officers, directors, employees,
              contractors, agents, and representatives (collectively,
              &quot;Treatment Provider Parties&quot;) may collect, use, and
              disclose Your Data, including Your personal information, in
              accordance with this Agreement and the Privacy Policy. To the
              extent Treatment Provider is a &quot;covered entity&quot; under
              the Health Insurance Portability and Accountability Act of 1996
              (as amended, and including all rules and regulations promulgated
              thereunder &quot;HIPAA&quot;) or the Health Information Technology
              for Economic and Clinical Health Act (as amended, including all
              rules and regulations promulgated thereunder, &quot;HITECH&quot;
              and collectively with HIPAA, &quot;Health Information Laws&quot;),
              Treatment Provider shall only share, access, and disclose Your
              protected health information in accordance with Health Information
              Laws and Treatment Provider shall, if applicable, implement
              compliance procedures in accordance with Health Information Laws.
            </p>

            <p className="py-1">
              <strong>(c) Communication with Treatment Provider.</strong> You
              acknowledge and agree that Treatment Provider, RepeatMD, and
              Treatment Provider Parties have the right to communicate with You
              regarding Your Membership, this Agreement or otherwise by any
              lawful method, including without limitation by mail, courier,
              telephone, email, text/SMS, and notifications within the Platform,
              and may communicate with You using any contact information you
              have provided to Treatment Provider. Treatment Provider, RepeatMD,
              and Treatment Provider Parties may also provide general
              member-facing or Treatment Provider location-facing communications
              or notices (if provided) on the Platform, including without
              limitation changes to Treatment Provider Policies and notices
              regarding inclement weather or changes to operating hours. Notices
              will be deemed given on the date deposited in the mail or given to
              a courier, the date a phone call is made or an email or SMS/text
              is sent, or the date posted in Treatment Provider location or in
              the Platform. You are responsible for providing accurate, current
              contact information and must promptly notify Treatment Provider,
              RepeatMD and Treatment Provider Parties if any of Your contact
              information changes. Treatment Provider, RepeatMD and Treatment
              Provider Parties will not be responsible for Your failure to
              receive any communication or notice as a result of Your failure to
              provide accurate and current contact information or any other
              actions outside of Treatment Provider, RepeatMD, or Treatment
              Provider Parties&apos; control, including, without limitation,
              because of any email filtering by Your ISP or email provider,
              insufficient space in Your email account, failure to update the
              App, or any errors or losses of any postal or delivery service.
              You hereby consent and give Treatment Provider, RepeatMD, and
              Treatment Provider Parties permission to use (or have a
              third-party provider use on Treatment Provider&apos;s behalf) an
              automated telephone dialing system and/or artificial or
              prerecorded voice (where applicable) to call or text You,
              including on or to any telephone number you provide to Treatment
              Provider, including your mobile phone.
            </p>

            <p className="py-1">
              <strong>(d) New Products and Services.</strong> Now and in the
              future, RepeatMD may develop, test, integrate, and otherwise
              market new products and services that are designed to improve Your
              experience, including products or services that leverage
              artificial intelligence powered applications, machine learning, or
              other machine-based systems that are designed to operate with
              varying levels of autonomy and otherwise infer or generate
              recommendations (collectively, &quot;Experimental Products&quot;).
              Subject to the terms of this Agreement, You explicitly consent to
              RepeatMD&apos;s use of Experimental Products on or in connection
              with the Platform. RepeatMD makes no representations or
              warranties, express or implied, regarding the accuracy or
              recommendations of or from Experimental Products. You also
              acknowledge and agree that RepeatMD may use Experimental Products
              to conduct Learning (defined below). As used herein,
              &quot;Learning&quot; means the process by which RepeatMD improves,
              refines, or further develops know-how, patterns, techniques, or
              methodologies used to improve, refine, or develop its products and
              services, or the outcome, content, or products resulting from such
              process; Learning also means the manner in which Experimental
              Products use, retain, derive from, extract from, or otherwise
              refer to Your Data to train, develop, improve, or enhance
              artificial intelligence or machine learning models, algorithms, or
              software.
            </p>

            <div className="py-2 text-bold2 text-bold2 underline">
              Article IV. Miscellaneous Provisions.
            </div>

            <div className="py-2 text-bold2">
              Section 4.01 Informal Dispute Resolution.
            </div>
            <p className="py-1">
              <strong>(a) Informal Dispute Resolution.</strong> RepeatMD strives
              to ensure that every experience You have with Treatment Provider
              exceeds Your expectations. If that doesn’t happen, and without
              limiting any other provision herein, please contact RepeatMD so
              the parties have an opportunity to discuss and address any problem
              or concern You may have. To do so, please contact RepeatMD at
              LEGAL@REPEATMD.COM and provide Your name, address, phone number
              and email address, a description of Your problem or concern and
              any specific relief You seek.
            </p>

            <div className="py-2 text-bold2">
              Section 4.02 Governing Law; Mandatory Arbitration of All Disputes.
            </div>
            <p className="py-1">
              <strong>(a) Covered Disputes.</strong> For purposes of this
              Agreement, and subject to the following exclusions, “Dispute”
              means any dispute, claim, or controversy between you and Treatment
              Provider regarding any aspect of your relationship with Treatment
              Provider, whether based in contract, statute, regulation,
              ordinance, tort (including without limitation fraud,
              misrepresentation, fraudulent inducement, personal injury or
              claims for lost, stolen, or damaged property, negligence, gross
              negligence or reckless behavior), or any other legal, statutory or
              equitable theory, and includes without limitation the validity,
              enforceability or scope of the Agreement, or any claims arising
              out of or relating to this Agreement. However, “Dispute” will not
              include any dispute, claim, or controversy between You and
              RepeatMD. As set forth in further detail below, You agree that any
              and all Disputes are subject to binding arbitration pursuant to
              the Federal Arbitration Act (Title 9 of the United States Code).
            </p>
            <p className="py-1">
              <strong>(b) Mandatory Arbitration.</strong> Except as expressly
              set forth herein, any Dispute shall be submitted to arbitration by
              one arbitrator mutually agreed upon by the parties, and if no
              agreement can be reached within 30 days after names of potential
              arbitrators have been proposed by Judicial Arbitration and
              Mediation Services, Inc. (“JAMS”), then by one arbitrator having
              reasonable experience in commercial disputes and who is chosen by
              JAMS. The arbitration shall take place in the State where the
              Treatment Provider Facility is located, in accordance with the
              JAMS rules then in effect, and judgment upon any award rendered in
              such arbitration will be binding and may be entered in any court
              having jurisdiction thereof. There shall be limited discovery
              prior to the arbitration hearing as follows: (a) exchange of
              witness lists and copies of documentary evidence and documents
              relating to the issues to be arbitrated, (b) depositions of all
              party witnesses, and (c) such other depositions as may be allowed
              by the arbitrators upon a showing of good cause. Depositions shall
              be conducted in accordance with the Federal Rules of Civil
              Procedure, the arbitrator shall be required to provide in writing
              to the parties the basis for the award or order of such
              arbitrator, and a court reporter shall record all hearings, with
              such record constituting the official transcript of such
              proceedings. If required for enforceability under the Federal
              Arbitration Act, Treatment Provider will pay all arbitrator’s
              costs and expenses. If not, those costs will be paid as specified
              in the above-referenced rules.
            </p>
            <p className="py-1">
              <strong>
                (c) WAIVER OF JURY TRIAL. EACH PARTY HEREBY WAIVES ITS RIGHTS TO
                A JURY TRIAL OF ANY CLAIM OR CAUSE OF ACTION BASED UPON OR
                ARISING OUT OF THIS AGREEMENT. THE SCOPE OF THIS WAIVER IS
                INTENDED TO BE ALL-ENCOMPASSING OF ANY AND ALL DISPUTES THAT MAY
                BE FILED IN ANY COURT AND THAT RELATE TO THE SUBJECT MATTER OF
                THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY DISPUTE,
                CONTRACT CLAIMS, TORT CLAIMS (INCLUDING NEGLIGENCE), BREACH OF
                DUTY CLAIMS, AND ALL OTHER COMMON LAW AND STATUTORY CLAIMS. THIS
                SECTION HAS BEEN FULLY DISCUSSED BY EACH OF THE PARTIES HERETO
                AND THESE PROVISIONS WILL NOT BE SUBJECT TO ANY EXCEPTIONS. EACH
                PARTY HERETO HEREBY FURTHER WARRANTS AND REPRESENTS THAT SUCH
                PARTY HAS REVIEWED THIS WAIVER WITH ITS LEGAL COUNSEL, AND THAT
                SUCH PARTY KNOWINGLY AND VOLUNTARILY WAIVES ITS JURY TRIAL
                RIGHTS FOLLOWING CONSULTATION WITH LEGAL COUNSEL.
              </strong>
            </p>
            <p className="py-1">
              <strong>(d) Class Action Waiver.</strong> You agree that the
              arbitration of any Dispute will be conducted on an individual, not
              a class-wide, basis, and that no arbitration proceeding may be
              consolidated with any other arbitration or other legal proceeding
              involving Treatment Provider or any other Person. You further
              agree that You, and anyone asserting a claim through you, will not
              be a class representative, class member, or otherwise participate
              in a class, representative, or consolidated proceeding against
              Treatment Provider, and that the arbitrator of any Dispute between
              You and Treatment Provider may not consolidate more than one
              Person’s claims, and may not otherwise preside over any form of a
              class or representative proceeding or claim (such as a class
              action, representative action, consolidated action or private
              attorney general action). If the foregoing class action waiver
              (“Class Action Waiver”) or any portion thereof is found to be
              invalid, illegal, unenforceable, unconscionable, void or voidable,
              then the Dispute will be decided by a court of competent
              jurisdiction.
            </p>
            <p className="py-1">
              <strong>(e) Governing Law.</strong> This Agreement, together with
              all claims and defenses related hereto or arising from this
              Agreement, will be governed by and construed in accordance with
              the laws of the State of Delaware, without regard to its conflict
              of laws rules.
            </p>

            <div className="py-2 text-bold2">Section 4.03 General Terms.</div>
            <p className="py-1">
              <strong>(a) Entire Agreement.</strong> This Agreement, all
              exhibits and appendices hereto, together with the Treatment
              Provider Policies, constitutes the entire and exclusive agreement
              between you and Treatment Provider relating to your Membership and
              supersedes any prior or contemporaneous representations,
              inducements, promises, understandings or agreements, whether oral,
              written or otherwise.
            </p>
            <p className="py-1">
              <strong>(b) Modifications.</strong> No provision of this
              Agreement, or the enforcement thereof, may be modified or waived,
              except as may be stated in a writing signed by Treatment Provider.
              Notwithstanding the foregoing or anything to the contrary herein,
              (i) Treatment Provider may, in its discretion, modify this
              Agreement at any time upon at least thirty (30) days’ notice to
              you and (ii) no provision of this Agreement that pertains to
              RepeatMD or impacts RepeatMD may be modified, waived, or amended
              without the prior written consent of RepeatMD.
            </p>
            <p className="py-1">
              <strong>(c) Severability.</strong> If any provision of this
              Agreement is invalid, illegal, or unenforceable in any
              jurisdiction, such invalidity, illegality, or unenforceability
              will not affect any other term or provision of this Agreement or
              invalidate or render unenforceable such term or provision in any
              other jurisdiction. Upon such determination that any term or other
              provision is invalid, illegal, or unenforceable, the parties shall
              negotiate in good faith to modify this Agreement so as to effect
              their original intent as closely as possible in a mutually
              acceptable manner in order that the transactions contemplated
              hereby be consummated as originally contemplated to the greatest
              extent possible.
            </p>
            <p className="py-1">
              <strong>(d) Construction.</strong> Each party has consulted with
              and has been represented by legal counsel of its own choice in
              connection with the meaning, interpretation, negotiation, drafting
              and effect of this Agreement, or has had the opportunity to do so.
              The normal rule of construction to the effect that any ambiguities
              are to be resolved against the drafting party shall not be
              employed in the interpretation of this Agreement or amendments
              hereto.
            </p>
            <p className="py-1">
              <strong>(e) No Third-Party Beneficiaries.</strong> This Agreement
              is solely between the parties hereto, and no third party, is a
              third-party beneficiary to this Agreement; provided, however, that
              RepeatMD and the Indemnified Parties are third-party beneficiaries
              of any provision or section of this Agreement pertaining to
              RepeatMD or Indemnified Parties, including without limitation
              Section 3.04 and Section 4.02.
            </p>
            <p className="py-1">
              <strong>(f) Assignment.</strong> Treatment Provider may assign or
              transfer this Agreement and Your Membership, whether by operation
              of law or otherwise, to an Affiliate of Treatment Provider or to a
              third party in the event of any merger, acquisition, sale of
              assets, change of control or other corporate transaction between
              Treatment Provider (or one of its Affiliates) and such third party
              (or one of its Affiliates), in each case without notice to you,
              and You hereby consent to any such assignment or transfer. You
              acknowledge that this Agreement is personal to You and that you
              have no rights to transfer or assign this Agreement to any other
              individual or entity.
            </p>
            <p className="py-1">
              <strong>(g) Anti-Kickback Laws.</strong> RepeatMD, Your Treatment
              Providers, and You acknowledge that the Federal Healthcare
              Programs Anti–Kickback Law, 42 U.S.C. § 1320a-7b, prohibits, among
              other things, giving or receiving remuneration in return for (or
              to induce) referrals, purchases, or recommendations of goods or
              services for which payment may be made in whole or in part by
              Medicare or Medicaid. It is the intention of the parties that this
              Agreement shall comply with the regulatory “safe harbor” under the
              Anti-Kickback Law for Personal Services, set forth in 42 C.F.R. §
              1001.952(d). If any portion of this Agreement is found not to be
              in compliance with applicable laws, rules, or regulations, that
              portion of the Agreement shall be deemed to be retroactively
              amended and reformed as necessary to comply with such laws, rules,
              or regulations, and the parties shall cooperate in taking whatever
              steps are necessary to ensure such compliance.
            </p>
            <p className="py-1">
              <strong>(h) Force Majeure.</strong> Except for failure to pay
              undisputed amounts when due, neither party shall be held
              responsible for any delay or failure in performance of any part of
              this Agreement to the extent such delay or failure is caused by
              fire, flood, strike, civil, governmental or military authority,
              act of God, or other similar causes beyond its control and without
              fault or negligence of the delayed or non-performing Party or its
              subcontractors.
            </p>
            <p className="py-1">
              <strong>(i) Headings.</strong> The headings used in this Agreement
              are for reference only and do not define, limit, or otherwise
              affect the meaning of any provisions hereof.
            </p>
            <p className="py-1">
              <strong>(j) Rewards and Benefits.</strong> RepeatMD is not
              responsible for the redemption of any reward or benefit provided
              to You by Treatment Provider. Treatment Provider is solely
              responsible for the redemption of any offer, reward, or benefit to
              You.
            </p>
          </div>
        </div>
      </ListModal>
    </div>
  );
};
